import { TLiftedFormModel } from '../../model/form.model';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import { FORM_MODIFIER } from '../../model/form.modifier';

export const UPDATE_THRESHOLD_FORM_MODEL = {
  createModel: (threshold?: number): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'INPUT',
            subType: 'number',
            value: threshold,
          },
          metadata: {
            keyName: 'threshold',
            label: 'edit_sp.Threshold',
            isRequired: true,
          },
        },
      ],
    });
  },

  createModelAndGeneratePayload: (threshold?: number): TLiftedFormModel => {
    const formModel = UPDATE_THRESHOLD_FORM_MODEL.createModel(threshold);
    return FORM_MODIFIER.generatePayload(formModel);
  },

  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },
};
